import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors } from "theme";

export const styles = (theme: Theme) => ({
	link: {
		color: theme.palette.secondary.main,
		alignItems: "center",
		textDecoration: "none",
		"&:hover": {
			textDecoration: "underline",
			cursor: "pointer"
		},
	},
	actionBar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	infoBanner: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 8,
		padding: '10px 16px',
		background: '#DFF4F7',
		borderRadius: 4,
	},
	tableHeaderCell: {
		color: baseColors.gray,
		fontSize: 13,
		background: 'transparent',
	},
} satisfies Record<string, CSSObject>)